<template>
  <!-- guard position: relative -->
  <div>
    <!-- TODO: transition-groupがまともになったら共通コンポーネントに分ける -->
    <transition-group name="fadeIn" tag="ul" :class="$style.alertList">
      <li
        v-for="{ alert, isAutoHidden } in alertItems"
        :key="alert.id"
        :class="$style.alertList__item"
      >
        <DolphinAlertItem
          v-bind="alert"
          :auto-hide="isAutoHidden"
          @close="$emit('close', $event)"
        />
      </li>
    </transition-group>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'
import DolphinAlertItem from './DolphinAlertItem.vue'
import type { AlertItem, AlertType } from '@/libs/alertPortal'
import { ALERT_TYPES } from '@/libs/alertPortal'

export { ALERT_TYPES }

const autoHiddenTypes: AlertType[] = [ALERT_TYPES.NOTICE, ALERT_TYPES.SUCCESS]

export default defineComponent({
  name: 'DolphinAlert',
  components: {
    DolphinAlertItem,
  },
  emits: ['close'],
  props: {
    items: {
      type: Array as PropType<ReadonlyArray<AlertItem>>,
      default: () => [],
    },
    enableAutoHide: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const alertItems = computed(() =>
      props.items.map(alert => ({
        alert,
        isAutoHidden:
          props.enableAutoHide && autoHiddenTypes.includes(alert.type),
      }))
    )

    return {
      alertItems,
    }
  },
})
</script>

<style lang="scss" module>
.alertList {
  position: relative;
  overflow: visible;

  &__item {
    transition: 300ms ease-out;
    transition-property: opacity transform;

    &:nth-child(n + 2) {
      margin-top: 2px;
    }
  }
}
</style>

<style lang="scss" scoped>
.fadeIn {
  // stylelint-disable selector-class-pattern
  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateY(-8%);
  }

  &-leave-active {
    position: absolute;
    width: 100%;
  }
  // stylelint-enable selector-class-pattern
}
</style>
